export default __webpack_public_path__ + "static/media/img_23.aa3c5046.jpg";